import { set } from 'date-fns';

/**
 * Clears the time portion of a Date object.
 *
 * @param {Date} date - The date to clear the time from.
 * @returns {Date} - The modified Date object with the time cleared.
 */
export const clearTime = (date: Date) => set(date, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
